<script lang="ts">
  import { Col, Container, Image, Row } from "sveltestrap";
  import BookmarkBlogSingle from "./BookmarkBlogSingle.svelte";
  import { Blogheader, Blogpara, Blogpara2 } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import CommentBox from "./CommentBox.svelte";
  let imgPath:string = "/assets/images/blog"

</script>
<BookmarkBlogSingle />
<Container fluid>
  <Row>
    <Col sm="12">
      <div class="blog-single">
        <div class="blog-box blog-details">
          <div class="banner-wrraper">
            <Image fluid class="w-100 bg-img-cover" src='{imgPath}/blog-single.jpg' alt="blog-main" />
          </div>
          <Card>
            <div slot="contentbody">
              <div class="blog-details">
                <ul class="blog-social">
                  <li>{'25 July 2022'}</li>
                  <li>
                    <i class="icofont icofont-user"/>{'Mark'} 
                    <span>{'Jecno'}</span>
                  </li>
                  <li>
                    <i class="icofont icofont-thumbs-up" />{'02'}
                    <span>{'Hits'}</span>
                  </li>
                  <li>
                    <i class="icofont icofont-ui-chat" />{'598 Comments'} 
                  </li>
                </ul>
                <h4>{Blogheader}</h4>
                <div class="single-blog-content-top">
                  <p>{Blogpara}</p>
                  <p>{Blogpara2}</p>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <CommentBox />
      </div>
    </Col>
  </Row>
</Container>